import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import EyeIcon from "../../../assets/svg/EyeIcon";
import {
  mobileVerification,
  registerUser,
  sendOtpToMobile,
} from "../../../redux/auth/actions";
import { useDispatch, useSelector } from "react-redux";
import hide from "../../../assets/svg/hide.png";
import { Modal } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import AppButton from "../Ui/AppButton";
import { parsePhoneNumber } from "libphonenumber-js";
import { ToasterNew } from "../../../utils/toaster";
import { AuthModals } from "../../../config/const";

const getParsedMobile = (mobileNumber) => {
  if (!mobileNumber) {
    return {
      mobile: "",
      country_code: "",
    };
  }

  const phoneNumber = parsePhoneNumber("+" + mobileNumber);
  return {
    mobile: phoneNumber.nationalNumber,
    country_code: phoneNumber.countryCallingCode,
  };
};

const RegisterModal = ({ show, handleModalChange }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const agentCode = useSelector((state) => state.app?.agentCode);
  const isOtpRequired = useSelector(
    (state) => state.app?.appDetails?.OTP === 0,
  );
  const [mobileNumber, setMobileNumber] = useState(false);
  const [loaders, setLoaders] = useState({
    sendOtp: false,
    verify: false,
    register: false,
  });
  const [registerConfig, setRegisterConfig] = useState({
    isOtpSent: false,
    isOtpVerified: false,
    otpValue: "",
    isOtpVerified: false,
  });

  const validateData = (data = null) => {
    const dataToValidate = data ? data : formData;
    const { name, username, password, confirmPassword, email } = dataToValidate;
    const newErrors = {};
    if (!name || name === "") {
      newErrors.name = "Name cannot be empty";
    }
    if (!username || username === "") {
      newErrors.userName = "User name cannot be empty";
    }
    if (username && (username.length < 4 || username.length > 15)) {
      newErrors.userName = "Username must be 4 to 15 characters.";
    }
    if (!/^[A-Za-z0-9 ]+$/.test(username)) {
      newErrors.userName = "Special characters are not allowed in username.";
    }
    // if (appDetails?.IS_EMAIL) {
    //   if (!email || email === "") {
    //     newErrors.email = "Email cannot be empty";
    //   }
    // }
    if (!password || password === "") {
      newErrors.password = "Password cannot be empty";
    }
    if (password && (password.length < 8 || password.length > 20)) {
      newErrors.password = "Password must be 8 to 20 characters.";
    }
    // if (!confirmPassword || confirmPassword === "") {
    //   newErrors.confirmPassword = "Confirm password cannot be empty";
    // } else if (password != confirmPassword) {
    //   newErrors.confirmPassword = "Password and Confirm password must be same";
    // }
    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async () => {
    if (isOtpRequired && !registerConfig.isOtpVerified) {
      ToasterNew.Success("Mobile not verified");
      return;
    }
    let errorsData = validateData();
    if (Object.keys(errorsData).length > 0) {
      return;
    }
    let dataToSend = { ...formData };
    delete dataToSend.confirmPassword;
    if (agentCode) {
      dataToSend.agent_code = agentCode;
    }

    setLoaders((p) => ({ ...p, register: true }));
    dispatch(
      registerUser(
        {
          ...dataToSend,
          ...getParsedMobile(mobileNumber),
        },
        () => {
          setLoaders((p) => ({ ...p, register: false }));
        },
        () => {
          handleModalChange(null);
        },
      ),
    );
    // checkIfExistingUserDetails(formData);
  };

  const handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let tempFormData = { ...formData, [fieldName]: fieldValue };
    setFormData(tempFormData);
    validateData(tempFormData);
  };

  const handleSendOtp = async () => {
    if (!isOtpRequired) {
      return;
    }
    if (!mobileNumber) {
      ToasterNew.Error("Mobile number is required");
      return;
    }
    setLoaders((p) => ({ ...p, sendOtp: true }));
    const response = await sendOtpToMobile(getParsedMobile(mobileNumber));
    setLoaders((p) => ({ ...p, sendOtp: false }));
    if (response) {
      setRegisterConfig((p) => ({ ...p, isOtpSent: true }));
      ToasterNew.Success("Otp sent on your mobile");
    }
  };

  const handleVerifyOtp = async () => {
    if (!registerConfig.isOtpSent || !registerConfig.otpValue) {
      return;
    }
    setLoaders((p) => ({ ...p, verify: true }));
    const response = await mobileVerification({
      ...getParsedMobile(mobileNumber),
      otp: registerConfig.otpValue,
    });
    setLoaders((p) => ({ ...p, verify: false }));
    if (response) {
      setRegisterConfig((p) => ({ ...p, isOtpVerified: true }));
      ToasterNew.Success("Mobile verified");
    }
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas login-modal signup-modal"}
      backdrop="static"
      keyboard={false}
      placement={"end"}
      centered
    >
      <Modal.Header
        closeButton
        onClick={() => handleModalChange(null)}
        closeVariant="white"
      >
        {/* <Modal.Title>Create an account!</Modal.Title> */}
      </Modal.Header>
      <Modal.Body>
        <div className="login-section">
          <div className="Login-rightPart">
            <div className="form-steps">
              <h2 className="h2">Registration</h2>
              {/* <p>Your number have been verified. Please create your account.</p> */}
              <Form>
                <Form.Group className="mb-3" controlId="formBasicName">
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Full name*"
                    onChange={handleChange}
                    isInvalid={!!errors.name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.name}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicName">
                  <Form.Control
                    type="text"
                    name="username"
                    placeholder="Choose Username*"
                    onChange={handleChange}
                    isInvalid={!!errors.userName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.userName}
                  </Form.Control.Feedback>
                </Form.Group>
                {/* <Form.Group className="mb-3" controlId="formBasicName">
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Email*"
                    onChange={handleChange}
                    isInvalid={!!errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors?.email}
                  </Form.Control.Feedback>
                </Form.Group> */}
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Choose Password*"
                    onChange={handleChange}
                    isInvalid={!!errors.password}
                  />
                  <span
                    className="icon"
                    onClick={() => setShowPassword((p) => !p)}
                  >
                    {showPassword ? <img src={hide} /> : <EyeIcon />}
                  </span>
                  <Form.Control.Feedback type="invalid">
                    {errors?.password}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group
                  className="mb-3 position-relative"
                  controlId="formBasicPassword"
                >
                  <PhoneInput
                    country={"in"}
                    inputProps={{
                      name: "phone",
                      required: true,
                    }}
                    onlyCountries={["in"]}
                    inputStyle={{
                      display: "block",
                      width: "100%",
                      lineHeight: 1.5,
                      color: "#fff",
                      backgroundColor: "#26324B",
                      backgroundClip: "padding-box",
                      border: "#26324B",
                      borderRadius: "10px",
                      padding: "0.7rem 0.75rem",
                      borderColor: "#26324B",
                      fontSize: "0.86rem",
                      minHeight: "47px",
                      paddingLeft: "50px",
                    }}
                    onChange={(phone) => {
                      setMobileNumber(phone);
                    }}
                  />
                  {isOtpRequired && (
                    <AppButton
                      text="Send Otp"
                      type="button"
                      className="verifybtn"
                      onClick={handleSendOtp}
                      isLoading={loaders.sendOtp}
                    />
                  )}
                </Form.Group>

                {isOtpRequired && (
                  <>
                    <Form.Group
                      className="mb-3 position-relative"
                      controlId="formBasicPassword"
                    >
                      <Form.Control
                        type="text"
                        placeholder="Enter OTP*"
                        onChange={(e) =>
                          setRegisterConfig((p) => ({
                            ...p,
                            otpValue: e.target.value,
                          }))
                        }
                      />
                      <span className="icon">{/* <EyeIcon /> */}</span>
                      <AppButton
                        text="Verify Otp"
                        type="button"
                        className="verifybtn"
                        onClick={handleVerifyOtp}
                        isLoading={loaders.verify}
                        disabled={!registerConfig.isOtpSent}
                      />
                    </Form.Group>
                  </>
                )}
                {/* <Form.Group
                  className="mb-3 position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    placeholder="Confirm Password*"
                    onChange={handleChange}
                    isInvalid={!!errors.confirmPassword}
                  />
                  <span
                    className="icon"
                    onClick={() => setShowConfirmPassword((p) => !p)}
                  >
                    {showConfirmPassword ? <img src={hide} /> : <EyeIcon />}
                  </span>
                  <Form.Control.Feedback type="invalid">
                    {errors?.confirmPassword}
                  </Form.Control.Feedback>
                </Form.Group> */}

                <Form.Group
                  className="mb-3 position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type={"text"}
                    name="agent_code"
                    placeholder="Please enter agent code"
                    value={agentCode}
                    // onChange={(e) => setAgentCode(e.target.value)}
                  />
                </Form.Group>
              </Form>

              <AppButton
                variant="primary"
                type="button"
                onClick={handleSubmit}
                text="Submit"
                isLoading={loaders.register}
                disabled={isOtpRequired ? !registerConfig.isOtpVerified : false}
              />
              <div className="sign-up mt-4">
                Have an account?
                <br />
                <a
                  role="button"
                  href="#"
                  onClick={() => {
                    handleModalChange(AuthModals.Login);
                  }}
                >
                  Login
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default RegisterModal;
